// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file public/auth.proto (package public, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../buf/validate/validate_pb";
import type { UserMessage, UserMessageSchema, UtmInfoMessage } from "../common/user_pb";
import { file_common_user } from "../common/user_pb";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file public/auth.proto.
 */
export const file_public_auth: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_common_user, file_google_protobuf_empty]);

/**
 * @generated from message public.SignInRequest
 */
export type SignInRequest = Message<"public.SignInRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message public.SignInRequest.
 * Use `create(SignInRequestSchema)` to create a new message.
 */
export const SignInRequestSchema: GenMessage<SignInRequest> = /*@__PURE__*/
  messageDesc(file_public_auth, 0);

/**
 * @generated from message public.SignUpRequest
 */
export type SignUpRequest = Message<"public.SignUpRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: optional string first_name = 3;
   */
  firstName?: string;

  /**
   * @generated from field: optional string last_name = 4;
   */
  lastName?: string;

  /**
   * @generated from field: optional string country = 5;
   */
  country?: string;

  /**
   * @generated from field: optional string timezone = 6;
   */
  timezone?: string;

  /**
   * @generated from field: optional string language = 7;
   */
  language?: string;

  /**
   * @generated from field: optional string referral_code = 8;
   */
  referralCode?: string;

  /**
   * @generated from field: optional string promo_code = 9;
   */
  promoCode?: string;

  /**
   * @generated from field: optional string affiliate_link_code = 10;
   */
  affiliateLinkCode?: string;

  /**
   * @generated from field: optional bool subscribe_for_news = 11;
   */
  subscribeForNews?: boolean;

  /**
   * @generated from field: optional common.UtmInfoMessage utm_info = 12;
   */
  utmInfo?: UtmInfoMessage;
};

/**
 * Describes the message public.SignUpRequest.
 * Use `create(SignUpRequestSchema)` to create a new message.
 */
export const SignUpRequestSchema: GenMessage<SignUpRequest> = /*@__PURE__*/
  messageDesc(file_public_auth, 1);

/**
 * @generated from message public.ForgotPasswordRequest
 */
export type ForgotPasswordRequest = Message<"public.ForgotPasswordRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message public.ForgotPasswordRequest.
 * Use `create(ForgotPasswordRequestSchema)` to create a new message.
 */
export const ForgotPasswordRequestSchema: GenMessage<ForgotPasswordRequest> = /*@__PURE__*/
  messageDesc(file_public_auth, 2);

/**
 * @generated from message public.ResetPasswordRequest
 */
export type ResetPasswordRequest = Message<"public.ResetPasswordRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message public.ResetPasswordRequest.
 * Use `create(ResetPasswordRequestSchema)` to create a new message.
 */
export const ResetPasswordRequestSchema: GenMessage<ResetPasswordRequest> = /*@__PURE__*/
  messageDesc(file_public_auth, 3);

/**
 * @generated from message public.ChangePasswordRequest
 */
export type ChangePasswordRequest = Message<"public.ChangePasswordRequest"> & {
  /**
   * @generated from field: string current_password = 1;
   */
  currentPassword: string;

  /**
   * @generated from field: string new_password = 2;
   */
  newPassword: string;
};

/**
 * Describes the message public.ChangePasswordRequest.
 * Use `create(ChangePasswordRequestSchema)` to create a new message.
 */
export const ChangePasswordRequestSchema: GenMessage<ChangePasswordRequest> = /*@__PURE__*/
  messageDesc(file_public_auth, 4);

/**
 * @generated from message public.GoogleOAuthRequest
 */
export type GoogleOAuthRequest = Message<"public.GoogleOAuthRequest"> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string linking_token = 2;
   */
  linkingToken?: string;

  /**
   * @generated from field: optional string password = 3;
   */
  password?: string;

  /**
   * @generated from field: optional common.UtmInfoMessage utm_info = 4;
   */
  utmInfo?: UtmInfoMessage;

  /**
   * @generated from field: optional string timezone = 5;
   */
  timezone?: string;

  /**
   * @generated from field: optional string country = 6;
   */
  country?: string;

  /**
   * @generated from field: string redirect_uri = 7;
   */
  redirectUri: string;
};

/**
 * Describes the message public.GoogleOAuthRequest.
 * Use `create(GoogleOAuthRequestSchema)` to create a new message.
 */
export const GoogleOAuthRequestSchema: GenMessage<GoogleOAuthRequest> = /*@__PURE__*/
  messageDesc(file_public_auth, 5);

/**
 * @generated from message public.GoogleLinkingRequired
 */
export type GoogleLinkingRequired = Message<"public.GoogleLinkingRequired"> & {
  /**
   * @generated from field: bool requires_linking = 1;
   */
  requiresLinking: boolean;

  /**
   * @generated from field: string linking_token = 2;
   */
  linkingToken: string;

  /**
   * @generated from field: string email = 3;
   */
  email: string;
};

/**
 * Describes the message public.GoogleLinkingRequired.
 * Use `create(GoogleLinkingRequiredSchema)` to create a new message.
 */
export const GoogleLinkingRequiredSchema: GenMessage<GoogleLinkingRequired> = /*@__PURE__*/
  messageDesc(file_public_auth, 6);

/**
 * @generated from message public.GoogleOAuthResponse
 */
export type GoogleOAuthResponse = Message<"public.GoogleOAuthResponse"> & {
  /**
   * @generated from oneof public.GoogleOAuthResponse.result
   */
  result: {
    /**
     * @generated from field: common.UserMessage user = 1;
     */
    value: UserMessage;
    case: "user";
  } | {
    /**
     * @generated from field: public.GoogleLinkingRequired linking_required = 2;
     */
    value: GoogleLinkingRequired;
    case: "linkingRequired";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public.GoogleOAuthResponse.
 * Use `create(GoogleOAuthResponseSchema)` to create a new message.
 */
export const GoogleOAuthResponseSchema: GenMessage<GoogleOAuthResponse> = /*@__PURE__*/
  messageDesc(file_public_auth, 7);

/**
 * @generated from message public.TwoFaRequired
 */
export type TwoFaRequired = Message<"public.TwoFaRequired"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message public.TwoFaRequired.
 * Use `create(TwoFaRequiredSchema)` to create a new message.
 */
export const TwoFaRequiredSchema: GenMessage<TwoFaRequired> = /*@__PURE__*/
  messageDesc(file_public_auth, 8);

/**
 * @generated from message public.DeletedAccount
 */
export type DeletedAccount = Message<"public.DeletedAccount"> & {
  /**
   * @generated from field: string restore_token = 1;
   */
  restoreToken: string;

  /**
   * @generated from field: int32 days_remaining = 2;
   */
  daysRemaining: number;
};

/**
 * Describes the message public.DeletedAccount.
 * Use `create(DeletedAccountSchema)` to create a new message.
 */
export const DeletedAccountSchema: GenMessage<DeletedAccount> = /*@__PURE__*/
  messageDesc(file_public_auth, 9);

/**
 * @generated from message public.SignInResponse
 */
export type SignInResponse = Message<"public.SignInResponse"> & {
  /**
   * @generated from oneof public.SignInResponse.result
   */
  result: {
    /**
     * @generated from field: common.UserMessage user = 1;
     */
    value: UserMessage;
    case: "user";
  } | {
    /**
     * @generated from field: public.TwoFaRequired two_fa_required = 2;
     */
    value: TwoFaRequired;
    case: "twoFaRequired";
  } | {
    /**
     * @generated from field: public.DeletedAccount deleted_account = 3;
     */
    value: DeletedAccount;
    case: "deletedAccount";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message public.SignInResponse.
 * Use `create(SignInResponseSchema)` to create a new message.
 */
export const SignInResponseSchema: GenMessage<SignInResponse> = /*@__PURE__*/
  messageDesc(file_public_auth, 10);

/**
 * @generated from message public.VerifyTwoFaRequest
 */
export type VerifyTwoFaRequest = Message<"public.VerifyTwoFaRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message public.VerifyTwoFaRequest.
 * Use `create(VerifyTwoFaRequestSchema)` to create a new message.
 */
export const VerifyTwoFaRequestSchema: GenMessage<VerifyTwoFaRequest> = /*@__PURE__*/
  messageDesc(file_public_auth, 11);

/**
 * @generated from message public.GetTwoFaTokenRequest
 */
export type GetTwoFaTokenRequest = Message<"public.GetTwoFaTokenRequest"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;
};

/**
 * Describes the message public.GetTwoFaTokenRequest.
 * Use `create(GetTwoFaTokenRequestSchema)` to create a new message.
 */
export const GetTwoFaTokenRequestSchema: GenMessage<GetTwoFaTokenRequest> = /*@__PURE__*/
  messageDesc(file_public_auth, 12);

/**
 * @generated from service public.AuthRPCService
 */
export const AuthRPCService: GenService<{
  /**
   * @generated from rpc public.AuthRPCService.SignUp
   */
  signUp: {
    methodKind: "unary";
    input: typeof SignUpRequestSchema;
    output: typeof UserMessageSchema;
  },
  /**
   * @generated from rpc public.AuthRPCService.SignIn
   */
  signIn: {
    methodKind: "unary";
    input: typeof SignInRequestSchema;
    output: typeof SignInResponseSchema;
  },
  /**
   * @generated from rpc public.AuthRPCService.VerifyTwoFa
   */
  verifyTwoFa: {
    methodKind: "unary";
    input: typeof VerifyTwoFaRequestSchema;
    output: typeof UserMessageSchema;
  },
  /**
   * @generated from rpc public.AuthRPCService.SignOut
   */
  signOut: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc public.AuthRPCService.Refresh
   */
  refresh: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof UserMessageSchema;
  },
  /**
   * @generated from rpc public.AuthRPCService.ForgotPassword
   */
  forgotPassword: {
    methodKind: "unary";
    input: typeof ForgotPasswordRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc public.AuthRPCService.ResetPassword
   */
  resetPassword: {
    methodKind: "unary";
    input: typeof ResetPasswordRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc public.AuthRPCService.ChangePassword
   */
  changePassword: {
    methodKind: "unary";
    input: typeof ChangePasswordRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc public.AuthRPCService.GoogleOAuth
   */
  googleOAuth: {
    methodKind: "unary";
    input: typeof GoogleOAuthRequestSchema;
    output: typeof GoogleOAuthResponseSchema;
  },
  /**
   * @generated from rpc public.AuthRPCService.GetTwoFaToken
   */
  getTwoFaToken: {
    methodKind: "unary";
    input: typeof GetTwoFaTokenRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_public_auth, 0);

